import integrationsClient, { type ApiDefinition } from '@/tsClient/servers/integrationsService';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/{provider}/user-workflows/{userWorkflowId}/register-manual-case']['POST'];
type Input = THIS_API['params'] & { caseNumber: string; courtDistrict: string; courtDivision: string };
type Output = THIS_API['response'];

const registerManualCase = async ({
  provider,
  userWorkflowId,
  caseNumber,
  courtDistrict,
  courtDivision,
}: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/{provider}/user-workflows/{userWorkflowId}/register-manual-case', {
    provider,
    userWorkflowId,
  });
  const response = await integrationsClient.post(path, { caseNumber, courtDistrict, courtDivision });
  return response.data;
};

export default registerManualCase;
